import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { appConfig } from '../../insaweb.config';
import { catchError, shareReplay } from 'rxjs/operators';
import { SharedMethodsModule } from '../insa-custom-scripts/sharedMethods';
import { EnableTwoFactorResponse } from '../insa-components/insa-login';

export interface TotpSetupResponse {
  Secret: string;
  QrCodeImageBase64: string;
  TwoFactorEnabled?: boolean;
  TwoFactorSetupCompleted?: boolean;
}

export interface EnableResponse {
  message: string;
  recoveryCodes: string[]; 
}

export interface TwoFactorStatus {
  TwoFactorEnabled: boolean;
}

export interface ValidateTwoFactorResponse {
  token: string;
}

export interface ValidateRecoveryResponse {
  token: string;
  requiresTwoFactorSetup?: boolean;
  message?: string;
}

@Injectable({ providedIn: 'root' })
export class TwoFactorService {
  private language = 'en';
  private hostAddress = appConfig.insaServiceAddress;
  private servicesURL = "/TwoFactor";


  constructor(private http: HttpClient) { }


  setupTotp(): Observable<TotpSetupResponse> {
    const headers = this.getPre2FAHeaders();
    const url = this.hostAddress + this.servicesURL + '/setupTotp';

    return this.http.post<TotpSetupResponse>(url, {}, { headers }).pipe(
      shareReplay(1),
      catchError(err => this.handleError(err, 'Could not setup TOTP'))
    );
  }

  enableTotp(code: string): Observable<any> {
    const headers = this.getPre2FAHeaders('application/json');
    const url = this.hostAddress + this.servicesURL + '/enableTotp';

    return this.http.post<EnableTwoFactorResponse>(
      url,
      { code },
      { headers }
    ).pipe(
      shareReplay(1),
      catchError(err => this.handleError(err, 'Could not enable TOTP'))
    );
  }

  validateTotp(code: string): Observable<ValidateTwoFactorResponse> {
  const headers = this.getPre2FAHeaders('application/json');
  const url = this.hostAddress + this.servicesURL + '/validateTotp';

  return this.http.post<ValidateTwoFactorResponse>(
    url,
    { code },
    { headers }
  ).pipe(
    shareReplay(1),
    catchError(err => this.handleError(err, 'Could not validate TOTP'))
  );
}


  validateTotpRecovery(code: string): Observable<ValidateRecoveryResponse> {
  const headers = this.getPre2FAHeaders('application/json');
  const url = this.hostAddress + this.servicesURL + '/validateTotp-recovery';

  return this.http.post<ValidateRecoveryResponse>(
    url,
    { code },
    { headers }
  ).pipe(
    shareReplay(1),
    catchError(err => this.handleError(err, 'Could not validate recovery code'))
  );
}

  private getPre2FAHeaders(contentType: string = 'application/json'): HttpHeaders {
    const token = localStorage.getItem('pre2fa_access_token');

    let headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    if (contentType) {
      headers = headers.set('Content-Type', contentType);
    }

    if (token) {
      headers = headers.set('Authorization', 'Bearer ' + token);
    }

    return headers;
  }

  private handleError(error: any, message: string) {
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    SharedMethodsModule.addNotification("#notification", message, false);
    return throwError(errMsg);
  }
}


// WEBPACK FOOTER //
// ./app/insa-services/insa-twofactor.service.ts